// Import: Middleware Action & Custom Types
import {
  CLEAN_FAILED_TRANSACTIONS_LIST_IPB,
  CLEAN_FAILED_TRANSACTIONS_LIST_IPB_ERROR,
} from '_models/redux/types';

// Action function
export const cleanFailedTransactionsListClean = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      type: CLEAN_FAILED_TRANSACTIONS_LIST_IPB,
      payload: undefined,
    });
  } catch (e) {
    dispatch({
      type: CLEAN_FAILED_TRANSACTIONS_LIST_IPB_ERROR,
      payload: undefined,
    });
  }
};
